import React from 'react';
import ProjectFilters from './projects/components/ProjectsFilters';
import ProjectsGrid from './projects/components/ProjectsGrid';
import ProjectsHeroSection from './projects/components/ProjectsHeroSection';
import ProjectsPagination from './projects/components/ProjectsPagination';
import { SORT_OPTIONS } from './projects/constants';
import { useProjectsCatalog } from './projects/hooks/useProjectsCatalog';
import { useProjectsData } from './projects/hooks/useProjectsData';

const Projects = () => {
  const { projects, status, errorMessage } = useProjectsData();
  const {
    currentPage,
    currentProjects,
    handleNextPage,
    handlePreviousPage,
    languageFilter,
    languageOptions,
    setLanguageFilter,
    setSortOption,
    sortOption,
    sortedProjects,
    totalPages,
  } = useProjectsCatalog(projects);

  return (
    <>
      <ProjectsHeroSection />

      <div className="site-bg-section py-20 px-6">
        <div className="container mx-auto">
          <ProjectFilters
            status={status}
            sortOption={sortOption}
            sortOptions={SORT_OPTIONS}
            onSortChange={(event) => setSortOption(event.target.value)}
            languageFilter={languageFilter}
            languageOptions={languageOptions}
            onLanguageChange={(event) => setLanguageFilter(event.target.value)}
          />

          <ProjectsGrid
            currentProjects={currentProjects}
            errorMessage={errorMessage}
            sortedProjects={sortedProjects}
            status={status}
          />

          <ProjectsPagination
            currentPage={currentPage}
            onNextPage={handleNextPage}
            onPreviousPage={handlePreviousPage}
            status={status}
            totalPages={totalPages}
          />
        </div>
      </div>
    </>
  );
};

export default Projects;
